import { createContractRequest } from './helper';
export const getGenerativeAssessments = createContractRequest({
    route: '/contract/generative/assessments',
    method: 'get',
    source: 'data',
});
